import { profileApi } from '../profileApi';
import { ProfileView } from '../types/profileTypes';
import { ProfileLookupRequest } from '../requests/profileLookupRequest';
import { ProfileSingleLookupRequest } from '../requests/profileSingleLookupRequest';
import { ProfileCreateRequest } from '../requests/profileCreateRequest';
import { RoleResponse } from '../responses/roleResponse';
import { ClaimTypeResponse } from '../responses/claimTypeResponse';
import { RoleChangeRequest } from '../requests/roleChangeRequest';

const profileEndpoints = profileApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get current user's profile
    // GET /MyProfile
    getMyProfile: builder.query<ProfileView, void>({
      query: () => 'MyProfile',
      providesTags: ['myProfile'],
    }),

    // Create a new profile
    // POST /Profile/Create
    createProfile: builder.mutation<ProfileView, ProfileCreateRequest>({
      query: (body) => ({
        url: 'Profile/Create',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['profileLookup'],
    }),

    // Lookup profiles by search criteria
    // POST /Profile/Lookup
    lookupProfiles: builder.mutation<ProfileView[], ProfileLookupRequest>({
      query: (body) => ({
        url: 'Profile/Lookup',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['profileLookup'],
    }),

    // Get a single profile
    // POST /Profile/SingleLookup
    singleProfileLookup: builder.mutation<ProfileView, ProfileSingleLookupRequest>({
      query: (body) => ({
        url: 'Profile/SingleLookup',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['userProfile'],
    }),

    // Change user role
    // POST /Profile/ChangeRole
    changeRole: builder.mutation<ProfileView, RoleChangeRequest>({
      query: (body) => ({
        url: 'Profile/ChangeRole',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['myProfile', 'userProfile'],
    }),

    // Get available roles
    // GET /Profile/AvailableRoles
    getAvailableRoles: builder.query<RoleResponse[], void>({
      query: () => 'Profile/AvailableRoles',
      providesTags: ['roles'],
    }),

    // Get available claims
    // GET /Profile/AvailableClaims
    getAvailableClaims: builder.query<ClaimTypeResponse[], void>({
      query: () => 'Profile/AvailableClaims',
      providesTags: ['claims'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetMyProfileQuery,
  useCreateProfileMutation,
  useLookupProfilesMutation,
  useSingleProfileLookupMutation,
  useChangeRoleMutation,
  useGetAvailableRolesQuery,
  useGetAvailableClaimsQuery,
} = profileEndpoints;
